// src/components/PartnerCarousel.jsx
// Auto-scrolling partner logo strip. Prefix "pc__" to avoid CSS collisions.
import "../styles/PartnerCarousel.css";

import logoLinkedin from "../logo_linkedin.jpg";
import logoAnyone   from "../logo-anyoneai.png";
import logoHallpa   from "../logo-hallpa.jpg";
import logoCuidafy  from "../logo-cuidafy.jpg";
import logoAlborada from "../logoalborada.jpg";
import logoAppel    from "../logoappel.png";
import logoGlobal   from "../logoglobal.png";
import frenteAmplio from "../frenteamplio.png";
import fuerzaPatria from "../fuerzapatria.png";
import logoCalyaan  from "../logocalyaan.png";
import logoCrypto   from "../logocrypto.png";
import logoXcloud   from "../logo-xcloud.jpg";
import logoApunam   from "../logo-apunam.png";
import logoLegisIA  from "../logo-legisia.png";
import logoSpaciuk  from "../logo-spaciuk.png";

// Partners without a logo file render as a text badge until one is added.
// invert: dark ink on transparent PNG, rendered as a white silhouette on the dark strip.
const PARTNERS = [
  { name: "LinkedIn",       logo: logoLinkedin },
  { name: "Anyone AI",      logo: logoAnyone },
  { name: "LEGIS-IA",       logo: logoLegisIA },
  { name: "APUNAM",         logo: logoApunam,  invert: true },
  { name: "Spaciuk",        logo: logoSpaciuk },
  { name: "HALLPA",         logo: logoHallpa },
  { name: "Cuidafy",        logo: logoCuidafy },
  { name: "Alborada",       logo: logoAlborada },
  { name: "Appel",          logo: logoAppel },
  { name: "Global Home",    logo: logoGlobal,  invert: true },
  { name: "Frente Amplio",  logo: frenteAmplio },
  { name: "Fuerza Patria",  logo: fuerzaPatria },
  { name: "Calyaan Co",     logo: logoCalyaan, invert: true },
  { name: "CryptoSeed.ai",  logo: logoCrypto },
  { name: "XCloud AU",      logo: logoXcloud },
];

const PartnerItem = ({ partner, hidden }) => (
  <li
    className={partner.invert ? "pc__item pc__item--invert" : "pc__item"}
    aria-hidden={hidden || undefined}
  >
    {partner.logo ? (
      <img
        src={partner.logo}
        alt={hidden ? "" : partner.name}
        title={partner.name}
        loading="lazy"
        decoding="async"
        width="140"
        height="60"
      />
    ) : (
      <span className="pc__text" title={partner.name}>{partner.name}</span>
    )}
  </li>
);

export const PartnerCarousel = () => (
  <section className="pc__section" aria-label="Empresas que confían en nosotros">
    <p className="pc__title">Empresas y organizaciones que confían en nosotros</p>
    <div className="pc__viewport">
      <ul className="pc__track">
        {PARTNERS.map((p) => <PartnerItem key={p.name} partner={p} />)}
        {/* Duplicate set for a seamless loop; hidden from assistive tech */}
        {PARTNERS.map((p) => <PartnerItem key={`dup-${p.name}`} partner={p} hidden />)}
      </ul>
    </div>
  </section>
);
